export default __webpack_public_path__ + "static/media/spinner-minus.92c202e9.svg";